import React from "react";
import { Link } from "react-router-dom";

import { FacebookIcon } from "src/assets/icons/facebook_icon";
import { LinkedInIcon } from "src/assets/icons/linkedin_icon";
import { MapMarkerIcon } from "src/assets/icons/map_marker_icon";
import { PhoneIcon } from "src/assets/icons/phone_icon";
import { TwitterIcon } from "src/assets/icons/twitter_icon";
import { YouTubeIcon } from "src/assets/icons/youtube_icon";
import { Routes } from "src/utils/routes";

import "./footer.scss";

/*
 * Main
 */

export const Footer = (): React.ReactElement => {
    return (
        <div className="acsi-global-footer" id="acsi-global-footer">
            <div className="global-inner">
                <a
                    aria-label="ACSI.org"
                    className="global-logo"
                    href="https://www.acsi.org/"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <img
                        alt="ASCI logo"
                        src="https://blog.acsi.org/wp-content/themes/acsi/library/images/acsi-logo-footer.png"
                    />
                </a>

                <div className="global-foot-nav">
                    <nav>
                        <ul className="gmenu">
                            <li>
                                <a href="https://blog.acsi.org/" rel="noopener noreferrer" target="_blank">
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a href="http://acsi.learningbuilder.com/" rel="noopener noreferrer" target="_blank">
                                    Learning
                                </a>
                            </li>
                            <li>
                                <a href="https://community.acsi.org/" rel="noopener noreferrer" target="_blank">
                                    Community
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div className="global-final">
                    <ul className="gmenu">
                        <li>
                            <div className="global-social">
                                <a
                                    aria-label="YouTube"
                                    href="https://www.youtube.com/channel/UCIEmCi89xeNpLC1affeyDCQ"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <YouTubeIcon />
                                </a>
                                <a
                                    aria-label="Facebook"
                                    href="https://www.facebook.com/ACSIUSA/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <FacebookIcon />
                                </a>
                                <a
                                    aria-label="Twitter"
                                    href="https://twitter.com/acsiusa"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <TwitterIcon />
                                </a>
                                <a
                                    aria-label="LinkedIn"
                                    className="footer-linkedin-link"
                                    href="https://www.linkedin.com/company/association-of-christian-schools-international"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <LinkedInIcon />
                                </a>
                            </div>
                        </li>
                        <li>
                            <div className="global-address">
                                <MapMarkerIcon />
                                P.O. Box 62249
                                <br /> Colorado Springs, CO 80962
                            </div>
                        </li>
                        <li>
                            <div className="global-phone">
                                <PhoneIcon />
                                800.367.5391
                            </div>
                        </li>
                        <li>
                            <div className="global-legal">
                                <Link to={`${Routes.about}#contact-us`}>Contact Us</Link>
                                <a
                                    href="https://www.acsi.org/school-services/career-center"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Careers
                                </a>
                                <a
                                    href="https://www.acsi.org/terms-conditions-privacy"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Privacy Statement
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
